export default {"src":"/_next/static/media/car_taxi.9202579f.svg","height":100,"width":150};